// extracted by mini-css-extract-plugin
module.exports = {"pulpoRadio":"select_pulpoRadio__1GQ33","select":"select_select__2A75N","dividerOption":"select_dividerOption__1_Ijd"};